import { createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history'
import { persistReducer } from 'redux-persist';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import storageSession from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk'

export const history = createBrowserHistory()

const persistConfig = {
  key: 'intlroot',
  storage:storageSession
}

const configureStore = rootReducer => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
  }) : compose;

  const store = createStore(
    connectRouter(history)(persistedReducer),
    composeEnhancers(
      applyMiddleware(
        thunk,
        routerMiddleware(history),
      ),
    ),
  )
  return store
}

export default configureStore
